/** @file Switches a 4-direction set between diagonal and cardinal layouts. */
import { z } from 'zod';
import { throwError } from '@pose2d/format/throwError';
import { defineCommand } from '../defineCommand';
import { command as setCount } from './setCount.command';
import { directionsDraft } from './directionsDraft';

/** direction.setLayout4: setCount { count: 4, layout4 } on an existing 4-set (the current layout is a no-op). */
export const command = defineCommand({
  name: 'direction.setLayout4',
  description: 'Switch a 4-direction set between diagonal (NE, SE, SW, NW) and cardinal (N, E, S, W); entries of the other layout are removed (a warning lists them).',
  input: z.object({ layout4: z.enum(['diagonal', 'cardinal']) }).strict(),
  apply(draft, input, ctx) {
    if (directionsDraft(draft, 'layout4').count !== 4) {
      throwError('VALIDATION', undefined, { path: 'layout4', hint: 'only 4-direction sets have a layout; run direction.setCount { count: 4 } instead' });
    }
    setCount.apply(draft, { count: 4, layout4: input.layout4 }, ctx);
  },
});
